var app = angular.module('Fourth', [
	'ngMaterial',
	'duScroll'
])

.config(function($mdThemingProvider) {
  $mdThemingProvider.disableTheming();
});